import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePage, useLanguage } from 'src/hooks';
import { Button } from 'src/components/general';
import notFoundIcon from 'src/icons/notFound.svg';
import styles from './pageNotFoundStyle.module.scss';

export const PageNotFound = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { homePage } = usePage();

  return (
    <div className={styles.container}>
      <img src={notFoundIcon} alt="" className={styles.img} />
      <div className={styles.label}>{t('page.notFount.title')}</div>
      {homePage && (
        <Button
          label={t('general.toHomePage')}
          onClick={() => {
            navigate(homePage);
          }}
          design="outline"
        />
      )}
    </div>
  );
};

export default PageNotFound;
